<template>
  <span
    class="ui-shimmer animate-pulse"
    :class="[roundedClass, shimmerVariant]"
  ></span>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { get } from 'lodash-es';

  const SM = 'sm';
  const MD = 'md';
  const LG = 'lg';
  const XL = 'xl';
  const XXL = '2xl';
  const FULL = 'full';

  enum ShimmerVariants {
    primary = 'bg-gray-150',
    secondary = 'bg-gray-250',
  }

  type Size =
    | typeof SM
    | typeof MD
    | typeof LG
    | typeof XL
    | typeof XXL
    | typeof FULL;

  const props = withDefaults(
    defineProps<{
      roundedSize?: Size;
      variant?: 'primary' | 'secondary';
    }>(),
    {
      roundedSize: 'md',
      variant: 'secondary',
    },
  );

  const roundedClass = computed(() =>
    get(
      {
        [SM]: 'rounded-sm',
        [MD]: 'rounded',
        [LG]: 'rounded-lg',
        [XL]: 'rounded-xl',
        [XXL]: 'rounded-2xl',
        [FULL]: 'rounded-full',
      },
      props.roundedSize,
    ),
  );

  const shimmerVariant = computed(() => ShimmerVariants[props.variant]);
</script>
